/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { RevGeo } from "./rev_geo";

export const protobufPackage = "eventos";

export interface Evento {
  tipoEvento: Evento_TiposEventos;
  rastreador: Evento_Rastreador | undefined;
  numeroSequencial: number;
  dataHoraEvento: number;
  dataHoraRecebimento: number;
  dataHoraArmazenamento: number;
  gps: Evento_Gps | undefined;
  gsm: Evento_Gsm | undefined;
  bateriaExterna: Evento_Bateria | undefined;
  flags: Evento_Flags | undefined;
  erbs: Evento_ERB[];
  revgeo: RevGeo | undefined;
  rawPackage: string;
  origemMensagem: Evento_OrigemMensagem;
  portas: Evento_EstadosPortas[];
  rfu1: Uint8Array;
  integracaoFornecedor: string;
  sensores: Evento_Sensores | undefined;
  can: Evento_DadosCan | undefined;
  p2p: Evento_P2P | undefined;
  objetoRastreavel: Evento_ObjetoRastreavel | undefined;
  identificaoMotorista: Evento_IdentificacaoMotorista | undefined;
}

export enum Evento_TiposEventos {
  POSICAO = 0,
  IGNICAO_ON = 1,
  IGNICAO_OFF = 2,
  BATERIA_EXTERNA_DESCONECTADA = 3,
  BATERIA_EXTERNA_RECONECTADA = 4,
  BATERIA_EXTERNA_BAIXA = 5,
  BATERIA_INTERNA_BAIXA = 6,
  POSICAO_EM_SLEEP = 7,
  ALERTA_DIRECAO_ACIMA_VELOCIDADE = 8,
  COLISAO = 9,
  PANICO = 10,
  PANICO_DESATIVADO = 11,
  JAMMING = 12,
  EMERGENCIA = 13,
  DETECCAO_P2P = 14,
  ECU_VIOLADA = 15,
  ECU_RESTAURADA = 16,
  IDENTIFICACAO_CONDUTOR = 17,
  IDENTIFICADOR_CONDUTOR_TIMEOUT = 18,
  IDENTIFICACAO_CONDUTOR_NAO_CADASTRADO = 19,
  FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE = 20,
  ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA = 21,
  FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA = 22,
  ALERTA_CURVA_BRUSCA = 23,
  ALERTA_FREADA_BRUSCA = 24,
  ALERTA_ACELERACAO_BRUSCA = 25,
  RFU_ENG = 90000,
  UNRECOGNIZED = -1,
}

export function evento_TiposEventosFromJSON(object: any): Evento_TiposEventos {
  switch (object) {
    case 0:
    case "POSICAO":
      return Evento_TiposEventos.POSICAO;
    case 1:
    case "IGNICAO_ON":
      return Evento_TiposEventos.IGNICAO_ON;
    case 2:
    case "IGNICAO_OFF":
      return Evento_TiposEventos.IGNICAO_OFF;
    case 3:
    case "BATERIA_EXTERNA_DESCONECTADA":
      return Evento_TiposEventos.BATERIA_EXTERNA_DESCONECTADA;
    case 4:
    case "BATERIA_EXTERNA_RECONECTADA":
      return Evento_TiposEventos.BATERIA_EXTERNA_RECONECTADA;
    case 5:
    case "BATERIA_EXTERNA_BAIXA":
      return Evento_TiposEventos.BATERIA_EXTERNA_BAIXA;
    case 6:
    case "BATERIA_INTERNA_BAIXA":
      return Evento_TiposEventos.BATERIA_INTERNA_BAIXA;
    case 7:
    case "POSICAO_EM_SLEEP":
      return Evento_TiposEventos.POSICAO_EM_SLEEP;
    case 8:
    case "ALERTA_DIRECAO_ACIMA_VELOCIDADE":
      return Evento_TiposEventos.ALERTA_DIRECAO_ACIMA_VELOCIDADE;
    case 9:
    case "COLISAO":
      return Evento_TiposEventos.COLISAO;
    case 10:
    case "PANICO":
      return Evento_TiposEventos.PANICO;
    case 11:
    case "PANICO_DESATIVADO":
      return Evento_TiposEventos.PANICO_DESATIVADO;
    case 12:
    case "JAMMING":
      return Evento_TiposEventos.JAMMING;
    case 13:
    case "EMERGENCIA":
      return Evento_TiposEventos.EMERGENCIA;
    case 14:
    case "DETECCAO_P2P":
      return Evento_TiposEventos.DETECCAO_P2P;
    case 15:
    case "ECU_VIOLADA":
      return Evento_TiposEventos.ECU_VIOLADA;
    case 16:
    case "ECU_RESTAURADA":
      return Evento_TiposEventos.ECU_RESTAURADA;
    case 17:
    case "IDENTIFICACAO_CONDUTOR":
      return Evento_TiposEventos.IDENTIFICACAO_CONDUTOR;
    case 18:
    case "IDENTIFICADOR_CONDUTOR_TIMEOUT":
      return Evento_TiposEventos.IDENTIFICADOR_CONDUTOR_TIMEOUT;
    case 19:
    case "IDENTIFICACAO_CONDUTOR_NAO_CADASTRADO":
      return Evento_TiposEventos.IDENTIFICACAO_CONDUTOR_NAO_CADASTRADO;
    case 20:
    case "FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE":
      return Evento_TiposEventos.FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE;
    case 21:
    case "ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA":
      return Evento_TiposEventos.ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA;
    case 22:
    case "FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA":
      return Evento_TiposEventos.FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA;
    case 23:
    case "ALERTA_CURVA_BRUSCA":
      return Evento_TiposEventos.ALERTA_CURVA_BRUSCA;
    case 24:
    case "ALERTA_FREADA_BRUSCA":
      return Evento_TiposEventos.ALERTA_FREADA_BRUSCA;
    case 25:
    case "ALERTA_ACELERACAO_BRUSCA":
      return Evento_TiposEventos.ALERTA_ACELERACAO_BRUSCA;
    case 90000:
    case "RFU_ENG":
      return Evento_TiposEventos.RFU_ENG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_TiposEventos.UNRECOGNIZED;
  }
}

export function evento_TiposEventosToJSON(object: Evento_TiposEventos): string {
  switch (object) {
    case Evento_TiposEventos.POSICAO:
      return "POSICAO";
    case Evento_TiposEventos.IGNICAO_ON:
      return "IGNICAO_ON";
    case Evento_TiposEventos.IGNICAO_OFF:
      return "IGNICAO_OFF";
    case Evento_TiposEventos.BATERIA_EXTERNA_DESCONECTADA:
      return "BATERIA_EXTERNA_DESCONECTADA";
    case Evento_TiposEventos.BATERIA_EXTERNA_RECONECTADA:
      return "BATERIA_EXTERNA_RECONECTADA";
    case Evento_TiposEventos.BATERIA_EXTERNA_BAIXA:
      return "BATERIA_EXTERNA_BAIXA";
    case Evento_TiposEventos.BATERIA_INTERNA_BAIXA:
      return "BATERIA_INTERNA_BAIXA";
    case Evento_TiposEventos.POSICAO_EM_SLEEP:
      return "POSICAO_EM_SLEEP";
    case Evento_TiposEventos.ALERTA_DIRECAO_ACIMA_VELOCIDADE:
      return "ALERTA_DIRECAO_ACIMA_VELOCIDADE";
    case Evento_TiposEventos.COLISAO:
      return "COLISAO";
    case Evento_TiposEventos.PANICO:
      return "PANICO";
    case Evento_TiposEventos.PANICO_DESATIVADO:
      return "PANICO_DESATIVADO";
    case Evento_TiposEventos.JAMMING:
      return "JAMMING";
    case Evento_TiposEventos.EMERGENCIA:
      return "EMERGENCIA";
    case Evento_TiposEventos.DETECCAO_P2P:
      return "DETECCAO_P2P";
    case Evento_TiposEventos.ECU_VIOLADA:
      return "ECU_VIOLADA";
    case Evento_TiposEventos.ECU_RESTAURADA:
      return "ECU_RESTAURADA";
    case Evento_TiposEventos.IDENTIFICACAO_CONDUTOR:
      return "IDENTIFICACAO_CONDUTOR";
    case Evento_TiposEventos.IDENTIFICADOR_CONDUTOR_TIMEOUT:
      return "IDENTIFICADOR_CONDUTOR_TIMEOUT";
    case Evento_TiposEventos.IDENTIFICACAO_CONDUTOR_NAO_CADASTRADO:
      return "IDENTIFICACAO_CONDUTOR_NAO_CADASTRADO";
    case Evento_TiposEventos.FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE:
      return "FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE";
    case Evento_TiposEventos.ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA:
      return "ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA";
    case Evento_TiposEventos.FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA:
      return "FIM_ALERTA_DIRECAO_ACIMA_VELOCIDADE_NA_CHUVA";
    case Evento_TiposEventos.ALERTA_CURVA_BRUSCA:
      return "ALERTA_CURVA_BRUSCA";
    case Evento_TiposEventos.ALERTA_FREADA_BRUSCA:
      return "ALERTA_FREADA_BRUSCA";
    case Evento_TiposEventos.ALERTA_ACELERACAO_BRUSCA:
      return "ALERTA_ACELERACAO_BRUSCA";
    case Evento_TiposEventos.RFU_ENG:
      return "RFU_ENG";
    case Evento_TiposEventos.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Evento_OrigemMensagem {
  GSM = 0,
  LORA_WAN = 1,
  LORA_P2P = 2,
  SIGFOX = 3,
  REDE_4G = 4,
  UNRECOGNIZED = -1,
}

export function evento_OrigemMensagemFromJSON(object: any): Evento_OrigemMensagem {
  switch (object) {
    case 0:
    case "GSM":
      return Evento_OrigemMensagem.GSM;
    case 1:
    case "LORA_WAN":
      return Evento_OrigemMensagem.LORA_WAN;
    case 2:
    case "LORA_P2P":
      return Evento_OrigemMensagem.LORA_P2P;
    case 3:
    case "SIGFOX":
      return Evento_OrigemMensagem.SIGFOX;
    case 4:
    case "REDE_4G":
      return Evento_OrigemMensagem.REDE_4G;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_OrigemMensagem.UNRECOGNIZED;
  }
}

export function evento_OrigemMensagemToJSON(object: Evento_OrigemMensagem): string {
  switch (object) {
    case Evento_OrigemMensagem.GSM:
      return "GSM";
    case Evento_OrigemMensagem.LORA_WAN:
      return "LORA_WAN";
    case Evento_OrigemMensagem.LORA_P2P:
      return "LORA_P2P";
    case Evento_OrigemMensagem.SIGFOX:
      return "SIGFOX";
    case Evento_OrigemMensagem.REDE_4G:
      return "REDE_4G";
    case Evento_OrigemMensagem.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Evento_Emergencia {
  statusEmergencia: Evento_Emergencia_StatusEmergencia;
  loraidMotivoEmergencia: number;
}

export enum Evento_Emergencia_StatusEmergencia {
  Entrada = 0,
  Saida = 1,
  Emergencia = 2,
  EmergenciaPorComando = 3,
  UNRECOGNIZED = -1,
}

export function evento_Emergencia_StatusEmergenciaFromJSON(object: any): Evento_Emergencia_StatusEmergencia {
  switch (object) {
    case 0:
    case "Entrada":
      return Evento_Emergencia_StatusEmergencia.Entrada;
    case 1:
    case "Saida":
      return Evento_Emergencia_StatusEmergencia.Saida;
    case 2:
    case "Emergencia":
      return Evento_Emergencia_StatusEmergencia.Emergencia;
    case 3:
    case "EmergenciaPorComando":
      return Evento_Emergencia_StatusEmergencia.EmergenciaPorComando;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_Emergencia_StatusEmergencia.UNRECOGNIZED;
  }
}

export function evento_Emergencia_StatusEmergenciaToJSON(object: Evento_Emergencia_StatusEmergencia): string {
  switch (object) {
    case Evento_Emergencia_StatusEmergencia.Entrada:
      return "Entrada";
    case Evento_Emergencia_StatusEmergencia.Saida:
      return "Saida";
    case Evento_Emergencia_StatusEmergencia.Emergencia:
      return "Emergencia";
    case Evento_Emergencia_StatusEmergencia.EmergenciaPorComando:
      return "EmergenciaPorComando";
    case Evento_Emergencia_StatusEmergencia.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Evento_Rastreador {
  numeroSerie: string;
  fabricante: Evento_Rastreador_Fabricante;
  versaoHardware: string;
  versaoFirmware: string;
  bateriaInterna: Evento_Bateria | undefined;
  modelo: number;
  motivoEnvio: string[];
  emergenciaInfo: Evento_Emergencia | undefined;
}

export enum Evento_Rastreador_Fabricante {
  MOVIDA = 0,
  MOBILOGIX = 1,
  INTEGRACAO = 2,
  MAXTRACK = 3,
  BWS = 4,
  QUECLINK = 5,
  SUNTECH = 6,
  ST_SUNLAB	 = 7,
  X3_TECH	 = 8,
  ALLCOM	 = 9,
  TELTONIKA	 = 10,
  UNRECOGNIZED = -1,
}

export function evento_Rastreador_FabricanteFromJSON(object: any): Evento_Rastreador_Fabricante {
  switch (object) {
    case 0:
    case "MOVIDA":
      return Evento_Rastreador_Fabricante.MOVIDA;
    case 1:
    case "MOBILOGIX":
      return Evento_Rastreador_Fabricante.MOBILOGIX;
    case 2:
    case "INTEGRACAO":
      return Evento_Rastreador_Fabricante.INTEGRACAO;
    case 3:
    case "MAXTRACK":
      return Evento_Rastreador_Fabricante.MAXTRACK;
    case 4:
    case "BWS":
      return Evento_Rastreador_Fabricante.BWS;
    case 5:
    case "QUECLINK":
      return Evento_Rastreador_Fabricante.QUECLINK;
    case 6:
    case "SUNTECH":
      return Evento_Rastreador_Fabricante.SUNTECH;
    case 7:
    case "ST_SUNLAB":
      return Evento_Rastreador_Fabricante.ST_SUNLAB;
    case 8:
    case "X3_TECH":
      return Evento_Rastreador_Fabricante.X3_TECH;
    case 9:
    case "ALLCOM":
      return Evento_Rastreador_Fabricante.ALLCOM;
    case 10:
    case "TELTONIKA":
      return Evento_Rastreador_Fabricante.TELTONIKA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_Rastreador_Fabricante.UNRECOGNIZED;
  }
}

export function evento_Rastreador_FabricanteToJSON(object: Evento_Rastreador_Fabricante): string {
  switch (object) {
    case Evento_Rastreador_Fabricante.MOVIDA:
      return "MOVIDA";
    case Evento_Rastreador_Fabricante.MOBILOGIX:
      return "MOBILOGIX";
    case Evento_Rastreador_Fabricante.INTEGRACAO:
      return "INTEGRACAO";
    case Evento_Rastreador_Fabricante.MAXTRACK:
      return "MAXTRACK";
    case Evento_Rastreador_Fabricante.BWS:
      return "BWS";
    case Evento_Rastreador_Fabricante.QUECLINK:
      return "QUECLINK";
    case Evento_Rastreador_Fabricante.SUNTECH:
      return "SUNTECH";
    case Evento_Rastreador_Fabricante.ST_SUNLAB:
      return "ST_SUNLAB";
    case Evento_Rastreador_Fabricante.X3_TECH:
      return "X3_TECH";
    case Evento_Rastreador_Fabricante.ALLCOM:
      return "ALLCOM";
    case Evento_Rastreador_Fabricante.TELTONIKA:
      return "TELTONIKA";
    case Evento_Rastreador_Fabricante.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Evento_Gps {
  fixado: boolean;
  numeroSatelites: number;
  hdop: number;
  latitude: number;
  longitude: number;
  velocidade: number;
  proa: number;
  altitude: number;
  odometro: number;
  antenaConectada: boolean;
  velocidadeMedia: number;
  odometroGps: number;
  relacaoSinalRuido: number;
}

export interface Evento_Gsm {
  sinal: boolean;
  qualidadeSinal: number;
}

export interface Evento_Bateria {
  ativa: boolean;
  conectada: boolean;
  tensao: number;
  porcentagem: number;
  horasExtimadasRestante: number;
}

export interface Evento_Flags {
  ignicao: boolean;
  ignicaoVirtual: boolean;
  posicaoOnline: boolean;
  bloqueador: boolean;
  botaoPanico: boolean;
  jamming: boolean;
  emergencia: boolean;
  conectadoCan: boolean;
  limpadoresParabrisa: boolean;
  freio: boolean;
  freioDeMao: boolean;
  freioMotor: boolean;
  cinto: boolean;
  portaFechada: boolean;
  portaTravada: boolean;
  farol: boolean;
  moduloRemovido: boolean;
  motorMalFuncionamento: boolean;
  ecuConectada: boolean;
  sirene: boolean;
}

export interface Evento_ERB {
  /** cell identity */
  cellid: number;
  /** base station identity */
  bsic: number;
  /** received signal strength indicator */
  rssi: number;
  /** timing advance */
  ta: number;
  /** location area code */
  lac: number;
  /** mobile country code */
  mcc: number;
  /** mobile network code */
  mnc: number;
  /** location code */
  locationCode: number;
  /** distance */
  distance: number;
  /** Level of GSM signal */
  sigGsm: number;
}

export interface Evento_EstadosPortas {
  equipamentoPorta: Evento_EstadosPortas_equipamento;
  numeroPorta: number;
  tipoPortas: Evento_EstadosPortas_tipo;
  valorSaida: Evento_EstadosPortas_estadoSaida;
  valorEntrada: string;
}

export enum Evento_EstadosPortas_estadoSaida {
  ATIVADA = 0,
  DESATIVADA = 1,
  UNRECOGNIZED = -1,
}

export function evento_EstadosPortas_estadoSaidaFromJSON(object: any): Evento_EstadosPortas_estadoSaida {
  switch (object) {
    case 0:
    case "ATIVADA":
      return Evento_EstadosPortas_estadoSaida.ATIVADA;
    case 1:
    case "DESATIVADA":
      return Evento_EstadosPortas_estadoSaida.DESATIVADA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_EstadosPortas_estadoSaida.UNRECOGNIZED;
  }
}

export function evento_EstadosPortas_estadoSaidaToJSON(object: Evento_EstadosPortas_estadoSaida): string {
  switch (object) {
    case Evento_EstadosPortas_estadoSaida.ATIVADA:
      return "ATIVADA";
    case Evento_EstadosPortas_estadoSaida.DESATIVADA:
      return "DESATIVADA";
    case Evento_EstadosPortas_estadoSaida.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Evento_EstadosPortas_tipo {
  ENTRADA = 0,
  SAIDA = 1,
  UNRECOGNIZED = -1,
}

export function evento_EstadosPortas_tipoFromJSON(object: any): Evento_EstadosPortas_tipo {
  switch (object) {
    case 0:
    case "ENTRADA":
      return Evento_EstadosPortas_tipo.ENTRADA;
    case 1:
    case "SAIDA":
      return Evento_EstadosPortas_tipo.SAIDA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_EstadosPortas_tipo.UNRECOGNIZED;
  }
}

export function evento_EstadosPortas_tipoToJSON(object: Evento_EstadosPortas_tipo): string {
  switch (object) {
    case Evento_EstadosPortas_tipo.ENTRADA:
      return "ENTRADA";
    case Evento_EstadosPortas_tipo.SAIDA:
      return "SAIDA";
    case Evento_EstadosPortas_tipo.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Evento_EstadosPortas_equipamento {
  RASTREADOR = 0,
  ACESSORIO = 1,
  DISPOSITIVO = 2,
  UNRECOGNIZED = -1,
}

export function evento_EstadosPortas_equipamentoFromJSON(object: any): Evento_EstadosPortas_equipamento {
  switch (object) {
    case 0:
    case "RASTREADOR":
      return Evento_EstadosPortas_equipamento.RASTREADOR;
    case 1:
    case "ACESSORIO":
      return Evento_EstadosPortas_equipamento.ACESSORIO;
    case 2:
    case "DISPOSITIVO":
      return Evento_EstadosPortas_equipamento.DISPOSITIVO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_EstadosPortas_equipamento.UNRECOGNIZED;
  }
}

export function evento_EstadosPortas_equipamentoToJSON(object: Evento_EstadosPortas_equipamento): string {
  switch (object) {
    case Evento_EstadosPortas_equipamento.RASTREADOR:
      return "RASTREADOR";
    case Evento_EstadosPortas_equipamento.ACESSORIO:
      return "ACESSORIO";
    case Evento_EstadosPortas_equipamento.DISPOSITIVO:
      return "DISPOSITIVO";
    case Evento_EstadosPortas_equipamento.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Evento_Sensores {
  odometro: number;
  rpm: number;
  velocidade: number;
  snapshotCamera: Uint8Array;
  maxioSerial: string;
  nivelCombustivel1: number;
  nivelCombustivel2: number;
  consumoCombustivel: number;
  posicaoAcelerador: number;
  marchaAtual: number;
  pressaoOleo: number;
  temperaturaOleo: number;
  tempMotor: number;
  pressaoPneu: number;
  horimetro: number;
}

export interface Evento_DadosCan {
  sensores: Evento_Sensores | undefined;
  flags: Evento_Flags | undefined;
}

export interface Evento_P2P {
  motivo: Evento_P2P_MotivoP2P;
  numeroSerie: string;
  loraId: string;
  dateTime: number;
  fabricante: Evento_Rastreador_Fabricante;
  latitude: number;
  longitude: number;
  fix: boolean;
  bateriaInternaTensao: number;
  bateriaInternaPorcentagem: number;
  bateriaExternaTensao: number;
  rssi: number;
  snr: number;
  rxTimestamp: number;
  rxCommandSequence: number;
}

export enum Evento_P2P_MotivoP2P {
  TRANSMICAO_PERIODICA = 0,
  TRANSMICAO_PERIODICA_SLEEP = 1,
  TRANSMICAO_EM_EMERGENCIA = 2,
  UNRECOGNIZED = -1,
}

export function evento_P2P_MotivoP2PFromJSON(object: any): Evento_P2P_MotivoP2P {
  switch (object) {
    case 0:
    case "TRANSMICAO_PERIODICA":
      return Evento_P2P_MotivoP2P.TRANSMICAO_PERIODICA;
    case 1:
    case "TRANSMICAO_PERIODICA_SLEEP":
      return Evento_P2P_MotivoP2P.TRANSMICAO_PERIODICA_SLEEP;
    case 2:
    case "TRANSMICAO_EM_EMERGENCIA":
      return Evento_P2P_MotivoP2P.TRANSMICAO_EM_EMERGENCIA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Evento_P2P_MotivoP2P.UNRECOGNIZED;
  }
}

export function evento_P2P_MotivoP2PToJSON(object: Evento_P2P_MotivoP2P): string {
  switch (object) {
    case Evento_P2P_MotivoP2P.TRANSMICAO_PERIODICA:
      return "TRANSMICAO_PERIODICA";
    case Evento_P2P_MotivoP2P.TRANSMICAO_PERIODICA_SLEEP:
      return "TRANSMICAO_PERIODICA_SLEEP";
    case Evento_P2P_MotivoP2P.TRANSMICAO_EM_EMERGENCIA:
      return "TRANSMICAO_EM_EMERGENCIA";
    case Evento_P2P_MotivoP2P.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Evento_ObjetoRastreavel {
  statusId: number;
  subsidiaryId: number;
  plate: string;
  id: number;
  chassi: string;
}

export interface Evento_IdentificacaoMotorista {
  identificador: string;
  motoristaid: number;
  motoristaNome: string;
}

function createBaseEvento(): Evento {
  return {
    tipoEvento: 0,
    rastreador: undefined,
    numeroSequencial: 0,
    dataHoraEvento: 0,
    dataHoraRecebimento: 0,
    dataHoraArmazenamento: 0,
    gps: undefined,
    gsm: undefined,
    bateriaExterna: undefined,
    flags: undefined,
    erbs: [],
    revgeo: undefined,
    rawPackage: "",
    origemMensagem: 0,
    portas: [],
    rfu1: new Uint8Array(0),
    integracaoFornecedor: "",
    sensores: undefined,
    can: undefined,
    p2p: undefined,
    objetoRastreavel: undefined,
    identificaoMotorista: undefined,
  };
}

export const Evento = {
  encode(message: Evento, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tipoEvento !== 0) {
      writer.uint32(8).int32(message.tipoEvento);
    }
    if (message.rastreador !== undefined) {
      Evento_Rastreador.encode(message.rastreador, writer.uint32(18).fork()).ldelim();
    }
    if (message.numeroSequencial !== 0) {
      writer.uint32(24).int32(message.numeroSequencial);
    }
    if (message.dataHoraEvento !== 0) {
      writer.uint32(32).int64(message.dataHoraEvento);
    }
    if (message.dataHoraRecebimento !== 0) {
      writer.uint32(40).int64(message.dataHoraRecebimento);
    }
    if (message.dataHoraArmazenamento !== 0) {
      writer.uint32(48).int64(message.dataHoraArmazenamento);
    }
    if (message.gps !== undefined) {
      Evento_Gps.encode(message.gps, writer.uint32(58).fork()).ldelim();
    }
    if (message.gsm !== undefined) {
      Evento_Gsm.encode(message.gsm, writer.uint32(66).fork()).ldelim();
    }
    if (message.bateriaExterna !== undefined) {
      Evento_Bateria.encode(message.bateriaExterna, writer.uint32(74).fork()).ldelim();
    }
    if (message.flags !== undefined) {
      Evento_Flags.encode(message.flags, writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.erbs) {
      Evento_ERB.encode(v!, writer.uint32(90).fork()).ldelim();
    }
    if (message.revgeo !== undefined) {
      RevGeo.encode(message.revgeo, writer.uint32(98).fork()).ldelim();
    }
    if (message.rawPackage !== "") {
      writer.uint32(106).string(message.rawPackage);
    }
    if (message.origemMensagem !== 0) {
      writer.uint32(112).int32(message.origemMensagem);
    }
    for (const v of message.portas) {
      Evento_EstadosPortas.encode(v!, writer.uint32(122).fork()).ldelim();
    }
    if (message.rfu1.length !== 0) {
      writer.uint32(130).bytes(message.rfu1);
    }
    if (message.integracaoFornecedor !== "") {
      writer.uint32(138).string(message.integracaoFornecedor);
    }
    if (message.sensores !== undefined) {
      Evento_Sensores.encode(message.sensores, writer.uint32(146).fork()).ldelim();
    }
    if (message.can !== undefined) {
      Evento_DadosCan.encode(message.can, writer.uint32(154).fork()).ldelim();
    }
    if (message.p2p !== undefined) {
      Evento_P2P.encode(message.p2p, writer.uint32(162).fork()).ldelim();
    }
    if (message.objetoRastreavel !== undefined) {
      Evento_ObjetoRastreavel.encode(message.objetoRastreavel, writer.uint32(170).fork()).ldelim();
    }
    if (message.identificaoMotorista !== undefined) {
      Evento_IdentificacaoMotorista.encode(message.identificaoMotorista, writer.uint32(178).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.tipoEvento = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.rastreador = Evento_Rastreador.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.numeroSequencial = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.dataHoraEvento = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.dataHoraRecebimento = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.dataHoraArmazenamento = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.gps = Evento_Gps.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.gsm = Evento_Gsm.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.bateriaExterna = Evento_Bateria.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.flags = Evento_Flags.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.erbs.push(Evento_ERB.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.revgeo = RevGeo.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.rawPackage = reader.string();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.origemMensagem = reader.int32() as any;
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.portas.push(Evento_EstadosPortas.decode(reader, reader.uint32()));
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.rfu1 = reader.bytes();
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.integracaoFornecedor = reader.string();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.sensores = Evento_Sensores.decode(reader, reader.uint32());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.can = Evento_DadosCan.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.p2p = Evento_P2P.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.objetoRastreavel = Evento_ObjetoRastreavel.decode(reader, reader.uint32());
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.identificaoMotorista = Evento_IdentificacaoMotorista.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento {
    return {
      tipoEvento: isSet(object.tipoEvento) ? evento_TiposEventosFromJSON(object.tipoEvento) : 0,
      rastreador: isSet(object.rastreador) ? Evento_Rastreador.fromJSON(object.rastreador) : undefined,
      numeroSequencial: isSet(object.numeroSequencial) ? Number(object.numeroSequencial) : 0,
      dataHoraEvento: isSet(object.dataHoraEvento) ? Number(object.dataHoraEvento) : 0,
      dataHoraRecebimento: isSet(object.dataHoraRecebimento) ? Number(object.dataHoraRecebimento) : 0,
      dataHoraArmazenamento: isSet(object.dataHoraArmazenamento) ? Number(object.dataHoraArmazenamento) : 0,
      gps: isSet(object.gps) ? Evento_Gps.fromJSON(object.gps) : undefined,
      gsm: isSet(object.gsm) ? Evento_Gsm.fromJSON(object.gsm) : undefined,
      bateriaExterna: isSet(object.bateriaExterna) ? Evento_Bateria.fromJSON(object.bateriaExterna) : undefined,
      flags: isSet(object.flags) ? Evento_Flags.fromJSON(object.flags) : undefined,
      erbs: Array.isArray(object?.erbs) ? object.erbs.map((e: any) => Evento_ERB.fromJSON(e)) : [],
      revgeo: isSet(object.revgeo) ? RevGeo.fromJSON(object.revgeo) : undefined,
      rawPackage: isSet(object.rawPackage) ? String(object.rawPackage) : "",
      origemMensagem: isSet(object.origemMensagem) ? evento_OrigemMensagemFromJSON(object.origemMensagem) : 0,
      portas: Array.isArray(object?.portas) ? object.portas.map((e: any) => Evento_EstadosPortas.fromJSON(e)) : [],
      rfu1: isSet(object.RFU1) ? bytesFromBase64(object.RFU1) : new Uint8Array(0),
      integracaoFornecedor: isSet(object.integracaoFornecedor) ? String(object.integracaoFornecedor) : "",
      sensores: isSet(object.sensores) ? Evento_Sensores.fromJSON(object.sensores) : undefined,
      can: isSet(object.can) ? Evento_DadosCan.fromJSON(object.can) : undefined,
      p2p: isSet(object.p2p) ? Evento_P2P.fromJSON(object.p2p) : undefined,
      objetoRastreavel: isSet(object.objetoRastreavel)
        ? Evento_ObjetoRastreavel.fromJSON(object.objetoRastreavel)
        : undefined,
      identificaoMotorista: isSet(object.identificaoMotorista)
        ? Evento_IdentificacaoMotorista.fromJSON(object.identificaoMotorista)
        : undefined,
    };
  },

  toJSON(message: Evento): unknown {
    const obj: any = {};
    if (message.tipoEvento !== 0) {
      obj.tipoEvento = evento_TiposEventosToJSON(message.tipoEvento);
    }
    if (message.rastreador !== undefined) {
      obj.rastreador = Evento_Rastreador.toJSON(message.rastreador);
    }
    if (message.numeroSequencial !== 0) {
      obj.numeroSequencial = Math.round(message.numeroSequencial);
    }
    if (message.dataHoraEvento !== 0) {
      obj.dataHoraEvento = Math.round(message.dataHoraEvento);
    }
    if (message.dataHoraRecebimento !== 0) {
      obj.dataHoraRecebimento = Math.round(message.dataHoraRecebimento);
    }
    if (message.dataHoraArmazenamento !== 0) {
      obj.dataHoraArmazenamento = Math.round(message.dataHoraArmazenamento);
    }
    if (message.gps !== undefined) {
      obj.gps = Evento_Gps.toJSON(message.gps);
    }
    if (message.gsm !== undefined) {
      obj.gsm = Evento_Gsm.toJSON(message.gsm);
    }
    if (message.bateriaExterna !== undefined) {
      obj.bateriaExterna = Evento_Bateria.toJSON(message.bateriaExterna);
    }
    if (message.flags !== undefined) {
      obj.flags = Evento_Flags.toJSON(message.flags);
    }
    if (message.erbs?.length) {
      obj.erbs = message.erbs.map((e) => Evento_ERB.toJSON(e));
    }
    if (message.revgeo !== undefined) {
      obj.revgeo = RevGeo.toJSON(message.revgeo);
    }
    if (message.rawPackage !== "") {
      obj.rawPackage = message.rawPackage;
    }
    if (message.origemMensagem !== 0) {
      obj.origemMensagem = evento_OrigemMensagemToJSON(message.origemMensagem);
    }
    if (message.portas?.length) {
      obj.portas = message.portas.map((e) => Evento_EstadosPortas.toJSON(e));
    }
    if (message.rfu1.length !== 0) {
      obj.RFU1 = base64FromBytes(message.rfu1);
    }
    if (message.integracaoFornecedor !== "") {
      obj.integracaoFornecedor = message.integracaoFornecedor;
    }
    if (message.sensores !== undefined) {
      obj.sensores = Evento_Sensores.toJSON(message.sensores);
    }
    if (message.can !== undefined) {
      obj.can = Evento_DadosCan.toJSON(message.can);
    }
    if (message.p2p !== undefined) {
      obj.p2p = Evento_P2P.toJSON(message.p2p);
    }
    if (message.objetoRastreavel !== undefined) {
      obj.objetoRastreavel = Evento_ObjetoRastreavel.toJSON(message.objetoRastreavel);
    }
    if (message.identificaoMotorista !== undefined) {
      obj.identificaoMotorista = Evento_IdentificacaoMotorista.toJSON(message.identificaoMotorista);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento>, I>>(base?: I): Evento {
    return Evento.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento>, I>>(object: I): Evento {
    const message = createBaseEvento();
    message.tipoEvento = object.tipoEvento ?? 0;
    message.rastreador = (object.rastreador !== undefined && object.rastreador !== null)
      ? Evento_Rastreador.fromPartial(object.rastreador)
      : undefined;
    message.numeroSequencial = object.numeroSequencial ?? 0;
    message.dataHoraEvento = object.dataHoraEvento ?? 0;
    message.dataHoraRecebimento = object.dataHoraRecebimento ?? 0;
    message.dataHoraArmazenamento = object.dataHoraArmazenamento ?? 0;
    message.gps = (object.gps !== undefined && object.gps !== null) ? Evento_Gps.fromPartial(object.gps) : undefined;
    message.gsm = (object.gsm !== undefined && object.gsm !== null) ? Evento_Gsm.fromPartial(object.gsm) : undefined;
    message.bateriaExterna = (object.bateriaExterna !== undefined && object.bateriaExterna !== null)
      ? Evento_Bateria.fromPartial(object.bateriaExterna)
      : undefined;
    message.flags = (object.flags !== undefined && object.flags !== null)
      ? Evento_Flags.fromPartial(object.flags)
      : undefined;
    message.erbs = object.erbs?.map((e) => Evento_ERB.fromPartial(e)) || [];
    message.revgeo = (object.revgeo !== undefined && object.revgeo !== null)
      ? RevGeo.fromPartial(object.revgeo)
      : undefined;
    message.rawPackage = object.rawPackage ?? "";
    message.origemMensagem = object.origemMensagem ?? 0;
    message.portas = object.portas?.map((e) => Evento_EstadosPortas.fromPartial(e)) || [];
    message.rfu1 = object.rfu1 ?? new Uint8Array(0);
    message.integracaoFornecedor = object.integracaoFornecedor ?? "";
    message.sensores = (object.sensores !== undefined && object.sensores !== null)
      ? Evento_Sensores.fromPartial(object.sensores)
      : undefined;
    message.can = (object.can !== undefined && object.can !== null)
      ? Evento_DadosCan.fromPartial(object.can)
      : undefined;
    message.p2p = (object.p2p !== undefined && object.p2p !== null) ? Evento_P2P.fromPartial(object.p2p) : undefined;
    message.objetoRastreavel = (object.objetoRastreavel !== undefined && object.objetoRastreavel !== null)
      ? Evento_ObjetoRastreavel.fromPartial(object.objetoRastreavel)
      : undefined;
    message.identificaoMotorista = (object.identificaoMotorista !== undefined && object.identificaoMotorista !== null)
      ? Evento_IdentificacaoMotorista.fromPartial(object.identificaoMotorista)
      : undefined;
    return message;
  },
};

function createBaseEvento_Emergencia(): Evento_Emergencia {
  return { statusEmergencia: 0, loraidMotivoEmergencia: 0 };
}

export const Evento_Emergencia = {
  encode(message: Evento_Emergencia, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.statusEmergencia !== 0) {
      writer.uint32(8).int32(message.statusEmergencia);
    }
    if (message.loraidMotivoEmergencia !== 0) {
      writer.uint32(16).uint32(message.loraidMotivoEmergencia);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Emergencia {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Emergencia();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.statusEmergencia = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.loraidMotivoEmergencia = reader.uint32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Emergencia {
    return {
      statusEmergencia: isSet(object.statusEmergencia)
        ? evento_Emergencia_StatusEmergenciaFromJSON(object.statusEmergencia)
        : 0,
      loraidMotivoEmergencia: isSet(object.loraidMotivoEmergencia) ? Number(object.loraidMotivoEmergencia) : 0,
    };
  },

  toJSON(message: Evento_Emergencia): unknown {
    const obj: any = {};
    if (message.statusEmergencia !== 0) {
      obj.statusEmergencia = evento_Emergencia_StatusEmergenciaToJSON(message.statusEmergencia);
    }
    if (message.loraidMotivoEmergencia !== 0) {
      obj.loraidMotivoEmergencia = Math.round(message.loraidMotivoEmergencia);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Emergencia>, I>>(base?: I): Evento_Emergencia {
    return Evento_Emergencia.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Emergencia>, I>>(object: I): Evento_Emergencia {
    const message = createBaseEvento_Emergencia();
    message.statusEmergencia = object.statusEmergencia ?? 0;
    message.loraidMotivoEmergencia = object.loraidMotivoEmergencia ?? 0;
    return message;
  },
};

function createBaseEvento_Rastreador(): Evento_Rastreador {
  return {
    numeroSerie: "",
    fabricante: 0,
    versaoHardware: "",
    versaoFirmware: "",
    bateriaInterna: undefined,
    modelo: 0,
    motivoEnvio: [],
    emergenciaInfo: undefined,
  };
}

export const Evento_Rastreador = {
  encode(message: Evento_Rastreador, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.numeroSerie !== "") {
      writer.uint32(10).string(message.numeroSerie);
    }
    if (message.fabricante !== 0) {
      writer.uint32(16).int32(message.fabricante);
    }
    if (message.versaoHardware !== "") {
      writer.uint32(26).string(message.versaoHardware);
    }
    if (message.versaoFirmware !== "") {
      writer.uint32(34).string(message.versaoFirmware);
    }
    if (message.bateriaInterna !== undefined) {
      Evento_Bateria.encode(message.bateriaInterna, writer.uint32(42).fork()).ldelim();
    }
    if (message.modelo !== 0) {
      writer.uint32(48).int32(message.modelo);
    }
    for (const v of message.motivoEnvio) {
      writer.uint32(58).string(v!);
    }
    if (message.emergenciaInfo !== undefined) {
      Evento_Emergencia.encode(message.emergenciaInfo, writer.uint32(66).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Rastreador {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Rastreador();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.numeroSerie = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.fabricante = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.versaoHardware = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.versaoFirmware = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.bateriaInterna = Evento_Bateria.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.modelo = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.motivoEnvio.push(reader.string());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.emergenciaInfo = Evento_Emergencia.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Rastreador {
    return {
      numeroSerie: isSet(object.numeroSerie) ? String(object.numeroSerie) : "",
      fabricante: isSet(object.fabricante) ? evento_Rastreador_FabricanteFromJSON(object.fabricante) : 0,
      versaoHardware: isSet(object.versaoHardware) ? String(object.versaoHardware) : "",
      versaoFirmware: isSet(object.versaoFirmware) ? String(object.versaoFirmware) : "",
      bateriaInterna: isSet(object.bateriaInterna) ? Evento_Bateria.fromJSON(object.bateriaInterna) : undefined,
      modelo: isSet(object.modelo) ? Number(object.modelo) : 0,
      motivoEnvio: Array.isArray(object?.motivoEnvio) ? object.motivoEnvio.map((e: any) => String(e)) : [],
      emergenciaInfo: isSet(object.emergenciaInfo) ? Evento_Emergencia.fromJSON(object.emergenciaInfo) : undefined,
    };
  },

  toJSON(message: Evento_Rastreador): unknown {
    const obj: any = {};
    if (message.numeroSerie !== "") {
      obj.numeroSerie = message.numeroSerie;
    }
    if (message.fabricante !== 0) {
      obj.fabricante = evento_Rastreador_FabricanteToJSON(message.fabricante);
    }
    if (message.versaoHardware !== "") {
      obj.versaoHardware = message.versaoHardware;
    }
    if (message.versaoFirmware !== "") {
      obj.versaoFirmware = message.versaoFirmware;
    }
    if (message.bateriaInterna !== undefined) {
      obj.bateriaInterna = Evento_Bateria.toJSON(message.bateriaInterna);
    }
    if (message.modelo !== 0) {
      obj.modelo = Math.round(message.modelo);
    }
    if (message.motivoEnvio?.length) {
      obj.motivoEnvio = message.motivoEnvio;
    }
    if (message.emergenciaInfo !== undefined) {
      obj.emergenciaInfo = Evento_Emergencia.toJSON(message.emergenciaInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Rastreador>, I>>(base?: I): Evento_Rastreador {
    return Evento_Rastreador.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Rastreador>, I>>(object: I): Evento_Rastreador {
    const message = createBaseEvento_Rastreador();
    message.numeroSerie = object.numeroSerie ?? "";
    message.fabricante = object.fabricante ?? 0;
    message.versaoHardware = object.versaoHardware ?? "";
    message.versaoFirmware = object.versaoFirmware ?? "";
    message.bateriaInterna = (object.bateriaInterna !== undefined && object.bateriaInterna !== null)
      ? Evento_Bateria.fromPartial(object.bateriaInterna)
      : undefined;
    message.modelo = object.modelo ?? 0;
    message.motivoEnvio = object.motivoEnvio?.map((e) => e) || [];
    message.emergenciaInfo = (object.emergenciaInfo !== undefined && object.emergenciaInfo !== null)
      ? Evento_Emergencia.fromPartial(object.emergenciaInfo)
      : undefined;
    return message;
  },
};

function createBaseEvento_Gps(): Evento_Gps {
  return {
    fixado: false,
    numeroSatelites: 0,
    hdop: 0,
    latitude: 0,
    longitude: 0,
    velocidade: 0,
    proa: 0,
    altitude: 0,
    odometro: 0,
    antenaConectada: false,
    velocidadeMedia: 0,
    odometroGps: 0,
    relacaoSinalRuido: 0,
  };
}

export const Evento_Gps = {
  encode(message: Evento_Gps, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fixado === true) {
      writer.uint32(8).bool(message.fixado);
    }
    if (message.numeroSatelites !== 0) {
      writer.uint32(16).int32(message.numeroSatelites);
    }
    if (message.hdop !== 0) {
      writer.uint32(24).int32(message.hdop);
    }
    if (message.latitude !== 0) {
      writer.uint32(37).float(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(45).float(message.longitude);
    }
    if (message.velocidade !== 0) {
      writer.uint32(53).float(message.velocidade);
    }
    if (message.proa !== 0) {
      writer.uint32(61).float(message.proa);
    }
    if (message.altitude !== 0) {
      writer.uint32(64).int32(message.altitude);
    }
    if (message.odometro !== 0) {
      writer.uint32(77).float(message.odometro);
    }
    if (message.antenaConectada === true) {
      writer.uint32(80).bool(message.antenaConectada);
    }
    if (message.velocidadeMedia !== 0) {
      writer.uint32(93).float(message.velocidadeMedia);
    }
    if (message.odometroGps !== 0) {
      writer.uint32(101).float(message.odometroGps);
    }
    if (message.relacaoSinalRuido !== 0) {
      writer.uint32(104).int32(message.relacaoSinalRuido);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Gps {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Gps();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.fixado = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.numeroSatelites = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.hdop = reader.int32();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.latitude = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.longitude = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.velocidade = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.proa = reader.float();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.altitude = reader.int32();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.odometro = reader.float();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.antenaConectada = reader.bool();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.velocidadeMedia = reader.float();
          continue;
        case 12:
          if (tag !== 101) {
            break;
          }

          message.odometroGps = reader.float();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.relacaoSinalRuido = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Gps {
    return {
      fixado: isSet(object.fixado) ? Boolean(object.fixado) : false,
      numeroSatelites: isSet(object.numeroSatelites) ? Number(object.numeroSatelites) : 0,
      hdop: isSet(object.hdop) ? Number(object.hdop) : 0,
      latitude: isSet(object.latitude) ? Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? Number(object.longitude) : 0,
      velocidade: isSet(object.velocidade) ? Number(object.velocidade) : 0,
      proa: isSet(object.proa) ? Number(object.proa) : 0,
      altitude: isSet(object.altitude) ? Number(object.altitude) : 0,
      odometro: isSet(object.odometro) ? Number(object.odometro) : 0,
      antenaConectada: isSet(object.antenaConectada) ? Boolean(object.antenaConectada) : false,
      velocidadeMedia: isSet(object.velocidadeMedia) ? Number(object.velocidadeMedia) : 0,
      odometroGps: isSet(object.odometroGps) ? Number(object.odometroGps) : 0,
      relacaoSinalRuido: isSet(object.relacaoSinalRuido) ? Number(object.relacaoSinalRuido) : 0,
    };
  },

  toJSON(message: Evento_Gps): unknown {
    const obj: any = {};
    if (message.fixado === true) {
      obj.fixado = message.fixado;
    }
    if (message.numeroSatelites !== 0) {
      obj.numeroSatelites = Math.round(message.numeroSatelites);
    }
    if (message.hdop !== 0) {
      obj.hdop = Math.round(message.hdop);
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.velocidade !== 0) {
      obj.velocidade = message.velocidade;
    }
    if (message.proa !== 0) {
      obj.proa = message.proa;
    }
    if (message.altitude !== 0) {
      obj.altitude = Math.round(message.altitude);
    }
    if (message.odometro !== 0) {
      obj.odometro = message.odometro;
    }
    if (message.antenaConectada === true) {
      obj.antenaConectada = message.antenaConectada;
    }
    if (message.velocidadeMedia !== 0) {
      obj.velocidadeMedia = message.velocidadeMedia;
    }
    if (message.odometroGps !== 0) {
      obj.odometroGps = message.odometroGps;
    }
    if (message.relacaoSinalRuido !== 0) {
      obj.relacaoSinalRuido = Math.round(message.relacaoSinalRuido);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Gps>, I>>(base?: I): Evento_Gps {
    return Evento_Gps.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Gps>, I>>(object: I): Evento_Gps {
    const message = createBaseEvento_Gps();
    message.fixado = object.fixado ?? false;
    message.numeroSatelites = object.numeroSatelites ?? 0;
    message.hdop = object.hdop ?? 0;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.velocidade = object.velocidade ?? 0;
    message.proa = object.proa ?? 0;
    message.altitude = object.altitude ?? 0;
    message.odometro = object.odometro ?? 0;
    message.antenaConectada = object.antenaConectada ?? false;
    message.velocidadeMedia = object.velocidadeMedia ?? 0;
    message.odometroGps = object.odometroGps ?? 0;
    message.relacaoSinalRuido = object.relacaoSinalRuido ?? 0;
    return message;
  },
};

function createBaseEvento_Gsm(): Evento_Gsm {
  return { sinal: false, qualidadeSinal: 0 };
}

export const Evento_Gsm = {
  encode(message: Evento_Gsm, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sinal === true) {
      writer.uint32(8).bool(message.sinal);
    }
    if (message.qualidadeSinal !== 0) {
      writer.uint32(16).int32(message.qualidadeSinal);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Gsm {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Gsm();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.sinal = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.qualidadeSinal = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Gsm {
    return {
      sinal: isSet(object.sinal) ? Boolean(object.sinal) : false,
      qualidadeSinal: isSet(object.qualidadeSinal) ? Number(object.qualidadeSinal) : 0,
    };
  },

  toJSON(message: Evento_Gsm): unknown {
    const obj: any = {};
    if (message.sinal === true) {
      obj.sinal = message.sinal;
    }
    if (message.qualidadeSinal !== 0) {
      obj.qualidadeSinal = Math.round(message.qualidadeSinal);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Gsm>, I>>(base?: I): Evento_Gsm {
    return Evento_Gsm.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Gsm>, I>>(object: I): Evento_Gsm {
    const message = createBaseEvento_Gsm();
    message.sinal = object.sinal ?? false;
    message.qualidadeSinal = object.qualidadeSinal ?? 0;
    return message;
  },
};

function createBaseEvento_Bateria(): Evento_Bateria {
  return { ativa: false, conectada: false, tensao: 0, porcentagem: 0, horasExtimadasRestante: 0 };
}

export const Evento_Bateria = {
  encode(message: Evento_Bateria, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ativa === true) {
      writer.uint32(8).bool(message.ativa);
    }
    if (message.conectada === true) {
      writer.uint32(16).bool(message.conectada);
    }
    if (message.tensao !== 0) {
      writer.uint32(29).float(message.tensao);
    }
    if (message.porcentagem !== 0) {
      writer.uint32(32).int32(message.porcentagem);
    }
    if (message.horasExtimadasRestante !== 0) {
      writer.uint32(40).int32(message.horasExtimadasRestante);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Bateria {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Bateria();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.ativa = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.conectada = reader.bool();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.tensao = reader.float();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.porcentagem = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.horasExtimadasRestante = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Bateria {
    return {
      ativa: isSet(object.ativa) ? Boolean(object.ativa) : false,
      conectada: isSet(object.conectada) ? Boolean(object.conectada) : false,
      tensao: isSet(object.tensao) ? Number(object.tensao) : 0,
      porcentagem: isSet(object.porcentagem) ? Number(object.porcentagem) : 0,
      horasExtimadasRestante: isSet(object.horasExtimadasRestante) ? Number(object.horasExtimadasRestante) : 0,
    };
  },

  toJSON(message: Evento_Bateria): unknown {
    const obj: any = {};
    if (message.ativa === true) {
      obj.ativa = message.ativa;
    }
    if (message.conectada === true) {
      obj.conectada = message.conectada;
    }
    if (message.tensao !== 0) {
      obj.tensao = message.tensao;
    }
    if (message.porcentagem !== 0) {
      obj.porcentagem = Math.round(message.porcentagem);
    }
    if (message.horasExtimadasRestante !== 0) {
      obj.horasExtimadasRestante = Math.round(message.horasExtimadasRestante);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Bateria>, I>>(base?: I): Evento_Bateria {
    return Evento_Bateria.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Bateria>, I>>(object: I): Evento_Bateria {
    const message = createBaseEvento_Bateria();
    message.ativa = object.ativa ?? false;
    message.conectada = object.conectada ?? false;
    message.tensao = object.tensao ?? 0;
    message.porcentagem = object.porcentagem ?? 0;
    message.horasExtimadasRestante = object.horasExtimadasRestante ?? 0;
    return message;
  },
};

function createBaseEvento_Flags(): Evento_Flags {
  return {
    ignicao: false,
    ignicaoVirtual: false,
    posicaoOnline: false,
    bloqueador: false,
    botaoPanico: false,
    jamming: false,
    emergencia: false,
    conectadoCan: false,
    limpadoresParabrisa: false,
    freio: false,
    freioDeMao: false,
    freioMotor: false,
    cinto: false,
    portaFechada: false,
    portaTravada: false,
    farol: false,
    moduloRemovido: false,
    motorMalFuncionamento: false,
    ecuConectada: false,
    sirene: false,
  };
}

export const Evento_Flags = {
  encode(message: Evento_Flags, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.ignicao === true) {
      writer.uint32(8).bool(message.ignicao);
    }
    if (message.ignicaoVirtual === true) {
      writer.uint32(16).bool(message.ignicaoVirtual);
    }
    if (message.posicaoOnline === true) {
      writer.uint32(24).bool(message.posicaoOnline);
    }
    if (message.bloqueador === true) {
      writer.uint32(32).bool(message.bloqueador);
    }
    if (message.botaoPanico === true) {
      writer.uint32(40).bool(message.botaoPanico);
    }
    if (message.jamming === true) {
      writer.uint32(48).bool(message.jamming);
    }
    if (message.emergencia === true) {
      writer.uint32(56).bool(message.emergencia);
    }
    if (message.conectadoCan === true) {
      writer.uint32(64).bool(message.conectadoCan);
    }
    if (message.limpadoresParabrisa === true) {
      writer.uint32(72).bool(message.limpadoresParabrisa);
    }
    if (message.freio === true) {
      writer.uint32(80).bool(message.freio);
    }
    if (message.freioDeMao === true) {
      writer.uint32(88).bool(message.freioDeMao);
    }
    if (message.freioMotor === true) {
      writer.uint32(96).bool(message.freioMotor);
    }
    if (message.cinto === true) {
      writer.uint32(104).bool(message.cinto);
    }
    if (message.portaFechada === true) {
      writer.uint32(112).bool(message.portaFechada);
    }
    if (message.portaTravada === true) {
      writer.uint32(120).bool(message.portaTravada);
    }
    if (message.farol === true) {
      writer.uint32(128).bool(message.farol);
    }
    if (message.moduloRemovido === true) {
      writer.uint32(136).bool(message.moduloRemovido);
    }
    if (message.motorMalFuncionamento === true) {
      writer.uint32(144).bool(message.motorMalFuncionamento);
    }
    if (message.ecuConectada === true) {
      writer.uint32(152).bool(message.ecuConectada);
    }
    if (message.sirene === true) {
      writer.uint32(160).bool(message.sirene);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Flags {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Flags();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.ignicao = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.ignicaoVirtual = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.posicaoOnline = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.bloqueador = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.botaoPanico = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.jamming = reader.bool();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.emergencia = reader.bool();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.conectadoCan = reader.bool();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.limpadoresParabrisa = reader.bool();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.freio = reader.bool();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.freioDeMao = reader.bool();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.freioMotor = reader.bool();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.cinto = reader.bool();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.portaFechada = reader.bool();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.portaTravada = reader.bool();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.farol = reader.bool();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.moduloRemovido = reader.bool();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.motorMalFuncionamento = reader.bool();
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.ecuConectada = reader.bool();
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.sirene = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Flags {
    return {
      ignicao: isSet(object.ignicao) ? Boolean(object.ignicao) : false,
      ignicaoVirtual: isSet(object.ignicaoVirtual) ? Boolean(object.ignicaoVirtual) : false,
      posicaoOnline: isSet(object.posicaoOnline) ? Boolean(object.posicaoOnline) : false,
      bloqueador: isSet(object.bloqueador) ? Boolean(object.bloqueador) : false,
      botaoPanico: isSet(object.botaoPanico) ? Boolean(object.botaoPanico) : false,
      jamming: isSet(object.jamming) ? Boolean(object.jamming) : false,
      emergencia: isSet(object.emergencia) ? Boolean(object.emergencia) : false,
      conectadoCan: isSet(object.conectadoCan) ? Boolean(object.conectadoCan) : false,
      limpadoresParabrisa: isSet(object.limpadoresParabrisa) ? Boolean(object.limpadoresParabrisa) : false,
      freio: isSet(object.freio) ? Boolean(object.freio) : false,
      freioDeMao: isSet(object.freioDeMao) ? Boolean(object.freioDeMao) : false,
      freioMotor: isSet(object.freioMotor) ? Boolean(object.freioMotor) : false,
      cinto: isSet(object.cinto) ? Boolean(object.cinto) : false,
      portaFechada: isSet(object.portaFechada) ? Boolean(object.portaFechada) : false,
      portaTravada: isSet(object.portaTravada) ? Boolean(object.portaTravada) : false,
      farol: isSet(object.farol) ? Boolean(object.farol) : false,
      moduloRemovido: isSet(object.moduloRemovido) ? Boolean(object.moduloRemovido) : false,
      motorMalFuncionamento: isSet(object.motorMalFuncionamento) ? Boolean(object.motorMalFuncionamento) : false,
      ecuConectada: isSet(object.ecuConectada) ? Boolean(object.ecuConectada) : false,
      sirene: isSet(object.sirene) ? Boolean(object.sirene) : false,
    };
  },

  toJSON(message: Evento_Flags): unknown {
    const obj: any = {};
    if (message.ignicao === true) {
      obj.ignicao = message.ignicao;
    }
    if (message.ignicaoVirtual === true) {
      obj.ignicaoVirtual = message.ignicaoVirtual;
    }
    if (message.posicaoOnline === true) {
      obj.posicaoOnline = message.posicaoOnline;
    }
    if (message.bloqueador === true) {
      obj.bloqueador = message.bloqueador;
    }
    if (message.botaoPanico === true) {
      obj.botaoPanico = message.botaoPanico;
    }
    if (message.jamming === true) {
      obj.jamming = message.jamming;
    }
    if (message.emergencia === true) {
      obj.emergencia = message.emergencia;
    }
    if (message.conectadoCan === true) {
      obj.conectadoCan = message.conectadoCan;
    }
    if (message.limpadoresParabrisa === true) {
      obj.limpadoresParabrisa = message.limpadoresParabrisa;
    }
    if (message.freio === true) {
      obj.freio = message.freio;
    }
    if (message.freioDeMao === true) {
      obj.freioDeMao = message.freioDeMao;
    }
    if (message.freioMotor === true) {
      obj.freioMotor = message.freioMotor;
    }
    if (message.cinto === true) {
      obj.cinto = message.cinto;
    }
    if (message.portaFechada === true) {
      obj.portaFechada = message.portaFechada;
    }
    if (message.portaTravada === true) {
      obj.portaTravada = message.portaTravada;
    }
    if (message.farol === true) {
      obj.farol = message.farol;
    }
    if (message.moduloRemovido === true) {
      obj.moduloRemovido = message.moduloRemovido;
    }
    if (message.motorMalFuncionamento === true) {
      obj.motorMalFuncionamento = message.motorMalFuncionamento;
    }
    if (message.ecuConectada === true) {
      obj.ecuConectada = message.ecuConectada;
    }
    if (message.sirene === true) {
      obj.sirene = message.sirene;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Flags>, I>>(base?: I): Evento_Flags {
    return Evento_Flags.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Flags>, I>>(object: I): Evento_Flags {
    const message = createBaseEvento_Flags();
    message.ignicao = object.ignicao ?? false;
    message.ignicaoVirtual = object.ignicaoVirtual ?? false;
    message.posicaoOnline = object.posicaoOnline ?? false;
    message.bloqueador = object.bloqueador ?? false;
    message.botaoPanico = object.botaoPanico ?? false;
    message.jamming = object.jamming ?? false;
    message.emergencia = object.emergencia ?? false;
    message.conectadoCan = object.conectadoCan ?? false;
    message.limpadoresParabrisa = object.limpadoresParabrisa ?? false;
    message.freio = object.freio ?? false;
    message.freioDeMao = object.freioDeMao ?? false;
    message.freioMotor = object.freioMotor ?? false;
    message.cinto = object.cinto ?? false;
    message.portaFechada = object.portaFechada ?? false;
    message.portaTravada = object.portaTravada ?? false;
    message.farol = object.farol ?? false;
    message.moduloRemovido = object.moduloRemovido ?? false;
    message.motorMalFuncionamento = object.motorMalFuncionamento ?? false;
    message.ecuConectada = object.ecuConectada ?? false;
    message.sirene = object.sirene ?? false;
    return message;
  },
};

function createBaseEvento_ERB(): Evento_ERB {
  return { cellid: 0, bsic: 0, rssi: 0, ta: 0, lac: 0, mcc: 0, mnc: 0, locationCode: 0, distance: 0, sigGsm: 0 };
}

export const Evento_ERB = {
  encode(message: Evento_ERB, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.cellid !== 0) {
      writer.uint32(8).int32(message.cellid);
    }
    if (message.bsic !== 0) {
      writer.uint32(16).int32(message.bsic);
    }
    if (message.rssi !== 0) {
      writer.uint32(24).int32(message.rssi);
    }
    if (message.ta !== 0) {
      writer.uint32(32).int32(message.ta);
    }
    if (message.lac !== 0) {
      writer.uint32(40).int32(message.lac);
    }
    if (message.mcc !== 0) {
      writer.uint32(48).int32(message.mcc);
    }
    if (message.mnc !== 0) {
      writer.uint32(56).int32(message.mnc);
    }
    if (message.locationCode !== 0) {
      writer.uint32(64).int32(message.locationCode);
    }
    if (message.distance !== 0) {
      writer.uint32(72).int32(message.distance);
    }
    if (message.sigGsm !== 0) {
      writer.uint32(80).int32(message.sigGsm);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_ERB {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_ERB();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.cellid = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.bsic = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.rssi = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.ta = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.lac = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.mcc = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.mnc = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.locationCode = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.distance = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.sigGsm = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_ERB {
    return {
      cellid: isSet(object.cellid) ? Number(object.cellid) : 0,
      bsic: isSet(object.bsic) ? Number(object.bsic) : 0,
      rssi: isSet(object.rssi) ? Number(object.rssi) : 0,
      ta: isSet(object.ta) ? Number(object.ta) : 0,
      lac: isSet(object.lac) ? Number(object.lac) : 0,
      mcc: isSet(object.mcc) ? Number(object.mcc) : 0,
      mnc: isSet(object.mnc) ? Number(object.mnc) : 0,
      locationCode: isSet(object.locationCode) ? Number(object.locationCode) : 0,
      distance: isSet(object.distance) ? Number(object.distance) : 0,
      sigGsm: isSet(object.sigGsm) ? Number(object.sigGsm) : 0,
    };
  },

  toJSON(message: Evento_ERB): unknown {
    const obj: any = {};
    if (message.cellid !== 0) {
      obj.cellid = Math.round(message.cellid);
    }
    if (message.bsic !== 0) {
      obj.bsic = Math.round(message.bsic);
    }
    if (message.rssi !== 0) {
      obj.rssi = Math.round(message.rssi);
    }
    if (message.ta !== 0) {
      obj.ta = Math.round(message.ta);
    }
    if (message.lac !== 0) {
      obj.lac = Math.round(message.lac);
    }
    if (message.mcc !== 0) {
      obj.mcc = Math.round(message.mcc);
    }
    if (message.mnc !== 0) {
      obj.mnc = Math.round(message.mnc);
    }
    if (message.locationCode !== 0) {
      obj.locationCode = Math.round(message.locationCode);
    }
    if (message.distance !== 0) {
      obj.distance = Math.round(message.distance);
    }
    if (message.sigGsm !== 0) {
      obj.sigGsm = Math.round(message.sigGsm);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_ERB>, I>>(base?: I): Evento_ERB {
    return Evento_ERB.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_ERB>, I>>(object: I): Evento_ERB {
    const message = createBaseEvento_ERB();
    message.cellid = object.cellid ?? 0;
    message.bsic = object.bsic ?? 0;
    message.rssi = object.rssi ?? 0;
    message.ta = object.ta ?? 0;
    message.lac = object.lac ?? 0;
    message.mcc = object.mcc ?? 0;
    message.mnc = object.mnc ?? 0;
    message.locationCode = object.locationCode ?? 0;
    message.distance = object.distance ?? 0;
    message.sigGsm = object.sigGsm ?? 0;
    return message;
  },
};

function createBaseEvento_EstadosPortas(): Evento_EstadosPortas {
  return { equipamentoPorta: 0, numeroPorta: 0, tipoPortas: 0, valorSaida: 0, valorEntrada: "" };
}

export const Evento_EstadosPortas = {
  encode(message: Evento_EstadosPortas, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.equipamentoPorta !== 0) {
      writer.uint32(8).int32(message.equipamentoPorta);
    }
    if (message.numeroPorta !== 0) {
      writer.uint32(16).int64(message.numeroPorta);
    }
    if (message.tipoPortas !== 0) {
      writer.uint32(24).int32(message.tipoPortas);
    }
    if (message.valorSaida !== 0) {
      writer.uint32(32).int32(message.valorSaida);
    }
    if (message.valorEntrada !== "") {
      writer.uint32(42).string(message.valorEntrada);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_EstadosPortas {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_EstadosPortas();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.equipamentoPorta = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.numeroPorta = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.tipoPortas = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.valorSaida = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.valorEntrada = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_EstadosPortas {
    return {
      equipamentoPorta: isSet(object.equipamentoPorta)
        ? evento_EstadosPortas_equipamentoFromJSON(object.equipamentoPorta)
        : 0,
      numeroPorta: isSet(object.numeroPorta) ? Number(object.numeroPorta) : 0,
      tipoPortas: isSet(object.tipoPortas) ? evento_EstadosPortas_tipoFromJSON(object.tipoPortas) : 0,
      valorSaida: isSet(object.valorSaida) ? evento_EstadosPortas_estadoSaidaFromJSON(object.valorSaida) : 0,
      valorEntrada: isSet(object.valorEntrada) ? String(object.valorEntrada) : "",
    };
  },

  toJSON(message: Evento_EstadosPortas): unknown {
    const obj: any = {};
    if (message.equipamentoPorta !== 0) {
      obj.equipamentoPorta = evento_EstadosPortas_equipamentoToJSON(message.equipamentoPorta);
    }
    if (message.numeroPorta !== 0) {
      obj.numeroPorta = Math.round(message.numeroPorta);
    }
    if (message.tipoPortas !== 0) {
      obj.tipoPortas = evento_EstadosPortas_tipoToJSON(message.tipoPortas);
    }
    if (message.valorSaida !== 0) {
      obj.valorSaida = evento_EstadosPortas_estadoSaidaToJSON(message.valorSaida);
    }
    if (message.valorEntrada !== "") {
      obj.valorEntrada = message.valorEntrada;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_EstadosPortas>, I>>(base?: I): Evento_EstadosPortas {
    return Evento_EstadosPortas.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_EstadosPortas>, I>>(object: I): Evento_EstadosPortas {
    const message = createBaseEvento_EstadosPortas();
    message.equipamentoPorta = object.equipamentoPorta ?? 0;
    message.numeroPorta = object.numeroPorta ?? 0;
    message.tipoPortas = object.tipoPortas ?? 0;
    message.valorSaida = object.valorSaida ?? 0;
    message.valorEntrada = object.valorEntrada ?? "";
    return message;
  },
};

function createBaseEvento_Sensores(): Evento_Sensores {
  return {
    odometro: 0,
    rpm: 0,
    velocidade: 0,
    snapshotCamera: new Uint8Array(0),
    maxioSerial: "",
    nivelCombustivel1: 0,
    nivelCombustivel2: 0,
    consumoCombustivel: 0,
    posicaoAcelerador: 0,
    marchaAtual: 0,
    pressaoOleo: 0,
    temperaturaOleo: 0,
    tempMotor: 0,
    pressaoPneu: 0,
    horimetro: 0,
  };
}

export const Evento_Sensores = {
  encode(message: Evento_Sensores, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.odometro !== 0) {
      writer.uint32(13).float(message.odometro);
    }
    if (message.rpm !== 0) {
      writer.uint32(16).uint32(message.rpm);
    }
    if (message.velocidade !== 0) {
      writer.uint32(29).float(message.velocidade);
    }
    if (message.snapshotCamera.length !== 0) {
      writer.uint32(34).bytes(message.snapshotCamera);
    }
    if (message.maxioSerial !== "") {
      writer.uint32(42).string(message.maxioSerial);
    }
    if (message.nivelCombustivel1 !== 0) {
      writer.uint32(48).uint32(message.nivelCombustivel1);
    }
    if (message.nivelCombustivel2 !== 0) {
      writer.uint32(56).uint32(message.nivelCombustivel2);
    }
    if (message.consumoCombustivel !== 0) {
      writer.uint32(64).uint32(message.consumoCombustivel);
    }
    if (message.posicaoAcelerador !== 0) {
      writer.uint32(72).uint32(message.posicaoAcelerador);
    }
    if (message.marchaAtual !== 0) {
      writer.uint32(80).uint32(message.marchaAtual);
    }
    if (message.pressaoOleo !== 0) {
      writer.uint32(88).uint32(message.pressaoOleo);
    }
    if (message.temperaturaOleo !== 0) {
      writer.uint32(96).uint32(message.temperaturaOleo);
    }
    if (message.tempMotor !== 0) {
      writer.uint32(104).uint32(message.tempMotor);
    }
    if (message.pressaoPneu !== 0) {
      writer.uint32(112).uint32(message.pressaoPneu);
    }
    if (message.horimetro !== 0) {
      writer.uint32(125).float(message.horimetro);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_Sensores {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_Sensores();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.odometro = reader.float();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.rpm = reader.uint32();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.velocidade = reader.float();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.snapshotCamera = reader.bytes();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.maxioSerial = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.nivelCombustivel1 = reader.uint32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.nivelCombustivel2 = reader.uint32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.consumoCombustivel = reader.uint32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.posicaoAcelerador = reader.uint32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.marchaAtual = reader.uint32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.pressaoOleo = reader.uint32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.temperaturaOleo = reader.uint32();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.tempMotor = reader.uint32();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.pressaoPneu = reader.uint32();
          continue;
        case 15:
          if (tag !== 125) {
            break;
          }

          message.horimetro = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_Sensores {
    return {
      odometro: isSet(object.odometro) ? Number(object.odometro) : 0,
      rpm: isSet(object.rpm) ? Number(object.rpm) : 0,
      velocidade: isSet(object.velocidade) ? Number(object.velocidade) : 0,
      snapshotCamera: isSet(object.snapshotCamera) ? bytesFromBase64(object.snapshotCamera) : new Uint8Array(0),
      maxioSerial: isSet(object.maxioSerial) ? String(object.maxioSerial) : "",
      nivelCombustivel1: isSet(object.nivelCombustivel1) ? Number(object.nivelCombustivel1) : 0,
      nivelCombustivel2: isSet(object.nivelCombustivel2) ? Number(object.nivelCombustivel2) : 0,
      consumoCombustivel: isSet(object.consumoCombustivel) ? Number(object.consumoCombustivel) : 0,
      posicaoAcelerador: isSet(object.posicaoAcelerador) ? Number(object.posicaoAcelerador) : 0,
      marchaAtual: isSet(object.marchaAtual) ? Number(object.marchaAtual) : 0,
      pressaoOleo: isSet(object.pressaoOleo) ? Number(object.pressaoOleo) : 0,
      temperaturaOleo: isSet(object.temperaturaOleo) ? Number(object.temperaturaOleo) : 0,
      tempMotor: isSet(object.tempMotor) ? Number(object.tempMotor) : 0,
      pressaoPneu: isSet(object.pressaoPneu) ? Number(object.pressaoPneu) : 0,
      horimetro: isSet(object.horimetro) ? Number(object.horimetro) : 0,
    };
  },

  toJSON(message: Evento_Sensores): unknown {
    const obj: any = {};
    if (message.odometro !== 0) {
      obj.odometro = message.odometro;
    }
    if (message.rpm !== 0) {
      obj.rpm = Math.round(message.rpm);
    }
    if (message.velocidade !== 0) {
      obj.velocidade = message.velocidade;
    }
    if (message.snapshotCamera.length !== 0) {
      obj.snapshotCamera = base64FromBytes(message.snapshotCamera);
    }
    if (message.maxioSerial !== "") {
      obj.maxioSerial = message.maxioSerial;
    }
    if (message.nivelCombustivel1 !== 0) {
      obj.nivelCombustivel1 = Math.round(message.nivelCombustivel1);
    }
    if (message.nivelCombustivel2 !== 0) {
      obj.nivelCombustivel2 = Math.round(message.nivelCombustivel2);
    }
    if (message.consumoCombustivel !== 0) {
      obj.consumoCombustivel = Math.round(message.consumoCombustivel);
    }
    if (message.posicaoAcelerador !== 0) {
      obj.posicaoAcelerador = Math.round(message.posicaoAcelerador);
    }
    if (message.marchaAtual !== 0) {
      obj.marchaAtual = Math.round(message.marchaAtual);
    }
    if (message.pressaoOleo !== 0) {
      obj.pressaoOleo = Math.round(message.pressaoOleo);
    }
    if (message.temperaturaOleo !== 0) {
      obj.temperaturaOleo = Math.round(message.temperaturaOleo);
    }
    if (message.tempMotor !== 0) {
      obj.tempMotor = Math.round(message.tempMotor);
    }
    if (message.pressaoPneu !== 0) {
      obj.pressaoPneu = Math.round(message.pressaoPneu);
    }
    if (message.horimetro !== 0) {
      obj.horimetro = message.horimetro;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_Sensores>, I>>(base?: I): Evento_Sensores {
    return Evento_Sensores.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_Sensores>, I>>(object: I): Evento_Sensores {
    const message = createBaseEvento_Sensores();
    message.odometro = object.odometro ?? 0;
    message.rpm = object.rpm ?? 0;
    message.velocidade = object.velocidade ?? 0;
    message.snapshotCamera = object.snapshotCamera ?? new Uint8Array(0);
    message.maxioSerial = object.maxioSerial ?? "";
    message.nivelCombustivel1 = object.nivelCombustivel1 ?? 0;
    message.nivelCombustivel2 = object.nivelCombustivel2 ?? 0;
    message.consumoCombustivel = object.consumoCombustivel ?? 0;
    message.posicaoAcelerador = object.posicaoAcelerador ?? 0;
    message.marchaAtual = object.marchaAtual ?? 0;
    message.pressaoOleo = object.pressaoOleo ?? 0;
    message.temperaturaOleo = object.temperaturaOleo ?? 0;
    message.tempMotor = object.tempMotor ?? 0;
    message.pressaoPneu = object.pressaoPneu ?? 0;
    message.horimetro = object.horimetro ?? 0;
    return message;
  },
};

function createBaseEvento_DadosCan(): Evento_DadosCan {
  return { sensores: undefined, flags: undefined };
}

export const Evento_DadosCan = {
  encode(message: Evento_DadosCan, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sensores !== undefined) {
      Evento_Sensores.encode(message.sensores, writer.uint32(10).fork()).ldelim();
    }
    if (message.flags !== undefined) {
      Evento_Flags.encode(message.flags, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_DadosCan {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_DadosCan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.sensores = Evento_Sensores.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.flags = Evento_Flags.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_DadosCan {
    return {
      sensores: isSet(object.sensores) ? Evento_Sensores.fromJSON(object.sensores) : undefined,
      flags: isSet(object.flags) ? Evento_Flags.fromJSON(object.flags) : undefined,
    };
  },

  toJSON(message: Evento_DadosCan): unknown {
    const obj: any = {};
    if (message.sensores !== undefined) {
      obj.sensores = Evento_Sensores.toJSON(message.sensores);
    }
    if (message.flags !== undefined) {
      obj.flags = Evento_Flags.toJSON(message.flags);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_DadosCan>, I>>(base?: I): Evento_DadosCan {
    return Evento_DadosCan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_DadosCan>, I>>(object: I): Evento_DadosCan {
    const message = createBaseEvento_DadosCan();
    message.sensores = (object.sensores !== undefined && object.sensores !== null)
      ? Evento_Sensores.fromPartial(object.sensores)
      : undefined;
    message.flags = (object.flags !== undefined && object.flags !== null)
      ? Evento_Flags.fromPartial(object.flags)
      : undefined;
    return message;
  },
};

function createBaseEvento_P2P(): Evento_P2P {
  return {
    motivo: 0,
    numeroSerie: "",
    loraId: "",
    dateTime: 0,
    fabricante: 0,
    latitude: 0,
    longitude: 0,
    fix: false,
    bateriaInternaTensao: 0,
    bateriaInternaPorcentagem: 0,
    bateriaExternaTensao: 0,
    rssi: 0,
    snr: 0,
    rxTimestamp: 0,
    rxCommandSequence: 0,
  };
}

export const Evento_P2P = {
  encode(message: Evento_P2P, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.motivo !== 0) {
      writer.uint32(8).int32(message.motivo);
    }
    if (message.numeroSerie !== "") {
      writer.uint32(18).string(message.numeroSerie);
    }
    if (message.loraId !== "") {
      writer.uint32(26).string(message.loraId);
    }
    if (message.dateTime !== 0) {
      writer.uint32(32).int64(message.dateTime);
    }
    if (message.fabricante !== 0) {
      writer.uint32(40).int32(message.fabricante);
    }
    if (message.latitude !== 0) {
      writer.uint32(53).float(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(61).float(message.longitude);
    }
    if (message.fix === true) {
      writer.uint32(64).bool(message.fix);
    }
    if (message.bateriaInternaTensao !== 0) {
      writer.uint32(77).float(message.bateriaInternaTensao);
    }
    if (message.bateriaInternaPorcentagem !== 0) {
      writer.uint32(85).float(message.bateriaInternaPorcentagem);
    }
    if (message.bateriaExternaTensao !== 0) {
      writer.uint32(93).float(message.bateriaExternaTensao);
    }
    if (message.rssi !== 0) {
      writer.uint32(96).int32(message.rssi);
    }
    if (message.snr !== 0) {
      writer.uint32(109).float(message.snr);
    }
    if (message.rxTimestamp !== 0) {
      writer.uint32(112).int64(message.rxTimestamp);
    }
    if (message.rxCommandSequence !== 0) {
      writer.uint32(120).int32(message.rxCommandSequence);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_P2P {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_P2P();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.motivo = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.numeroSerie = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.loraId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.dateTime = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.fabricante = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.latitude = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.longitude = reader.float();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.fix = reader.bool();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.bateriaInternaTensao = reader.float();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.bateriaInternaPorcentagem = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.bateriaExternaTensao = reader.float();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.rssi = reader.int32();
          continue;
        case 13:
          if (tag !== 109) {
            break;
          }

          message.snr = reader.float();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.rxTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.rxCommandSequence = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_P2P {
    return {
      motivo: isSet(object.motivo) ? evento_P2P_MotivoP2PFromJSON(object.motivo) : 0,
      numeroSerie: isSet(object.numeroSerie) ? String(object.numeroSerie) : "",
      loraId: isSet(object.loraId) ? String(object.loraId) : "",
      dateTime: isSet(object.dateTime) ? Number(object.dateTime) : 0,
      fabricante: isSet(object.fabricante) ? evento_Rastreador_FabricanteFromJSON(object.fabricante) : 0,
      latitude: isSet(object.latitude) ? Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? Number(object.longitude) : 0,
      fix: isSet(object.fix) ? Boolean(object.fix) : false,
      bateriaInternaTensao: isSet(object.bateriaInternaTensao) ? Number(object.bateriaInternaTensao) : 0,
      bateriaInternaPorcentagem: isSet(object.bateriaInternaPorcentagem) ? Number(object.bateriaInternaPorcentagem) : 0,
      bateriaExternaTensao: isSet(object.bateriaExternaTensao) ? Number(object.bateriaExternaTensao) : 0,
      rssi: isSet(object.rssi) ? Number(object.rssi) : 0,
      snr: isSet(object.snr) ? Number(object.snr) : 0,
      rxTimestamp: isSet(object.rxTimestamp) ? Number(object.rxTimestamp) : 0,
      rxCommandSequence: isSet(object.rxCommandSequence) ? Number(object.rxCommandSequence) : 0,
    };
  },

  toJSON(message: Evento_P2P): unknown {
    const obj: any = {};
    if (message.motivo !== 0) {
      obj.motivo = evento_P2P_MotivoP2PToJSON(message.motivo);
    }
    if (message.numeroSerie !== "") {
      obj.numeroSerie = message.numeroSerie;
    }
    if (message.loraId !== "") {
      obj.loraId = message.loraId;
    }
    if (message.dateTime !== 0) {
      obj.dateTime = Math.round(message.dateTime);
    }
    if (message.fabricante !== 0) {
      obj.fabricante = evento_Rastreador_FabricanteToJSON(message.fabricante);
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.fix === true) {
      obj.fix = message.fix;
    }
    if (message.bateriaInternaTensao !== 0) {
      obj.bateriaInternaTensao = message.bateriaInternaTensao;
    }
    if (message.bateriaInternaPorcentagem !== 0) {
      obj.bateriaInternaPorcentagem = message.bateriaInternaPorcentagem;
    }
    if (message.bateriaExternaTensao !== 0) {
      obj.bateriaExternaTensao = message.bateriaExternaTensao;
    }
    if (message.rssi !== 0) {
      obj.rssi = Math.round(message.rssi);
    }
    if (message.snr !== 0) {
      obj.snr = message.snr;
    }
    if (message.rxTimestamp !== 0) {
      obj.rxTimestamp = Math.round(message.rxTimestamp);
    }
    if (message.rxCommandSequence !== 0) {
      obj.rxCommandSequence = Math.round(message.rxCommandSequence);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_P2P>, I>>(base?: I): Evento_P2P {
    return Evento_P2P.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_P2P>, I>>(object: I): Evento_P2P {
    const message = createBaseEvento_P2P();
    message.motivo = object.motivo ?? 0;
    message.numeroSerie = object.numeroSerie ?? "";
    message.loraId = object.loraId ?? "";
    message.dateTime = object.dateTime ?? 0;
    message.fabricante = object.fabricante ?? 0;
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    message.fix = object.fix ?? false;
    message.bateriaInternaTensao = object.bateriaInternaTensao ?? 0;
    message.bateriaInternaPorcentagem = object.bateriaInternaPorcentagem ?? 0;
    message.bateriaExternaTensao = object.bateriaExternaTensao ?? 0;
    message.rssi = object.rssi ?? 0;
    message.snr = object.snr ?? 0;
    message.rxTimestamp = object.rxTimestamp ?? 0;
    message.rxCommandSequence = object.rxCommandSequence ?? 0;
    return message;
  },
};

function createBaseEvento_ObjetoRastreavel(): Evento_ObjetoRastreavel {
  return { statusId: 0, subsidiaryId: 0, plate: "", id: 0, chassi: "" };
}

export const Evento_ObjetoRastreavel = {
  encode(message: Evento_ObjetoRastreavel, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.statusId !== 0) {
      writer.uint32(8).int32(message.statusId);
    }
    if (message.subsidiaryId !== 0) {
      writer.uint32(16).int32(message.subsidiaryId);
    }
    if (message.plate !== "") {
      writer.uint32(26).string(message.plate);
    }
    if (message.id !== 0) {
      writer.uint32(32).int64(message.id);
    }
    if (message.chassi !== "") {
      writer.uint32(42).string(message.chassi);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_ObjetoRastreavel {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_ObjetoRastreavel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.statusId = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.subsidiaryId = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.plate = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.chassi = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_ObjetoRastreavel {
    return {
      statusId: isSet(object.statusId) ? Number(object.statusId) : 0,
      subsidiaryId: isSet(object.subsidiaryId) ? Number(object.subsidiaryId) : 0,
      plate: isSet(object.plate) ? String(object.plate) : "",
      id: isSet(object.id) ? Number(object.id) : 0,
      chassi: isSet(object.chassi) ? String(object.chassi) : "",
    };
  },

  toJSON(message: Evento_ObjetoRastreavel): unknown {
    const obj: any = {};
    if (message.statusId !== 0) {
      obj.statusId = Math.round(message.statusId);
    }
    if (message.subsidiaryId !== 0) {
      obj.subsidiaryId = Math.round(message.subsidiaryId);
    }
    if (message.plate !== "") {
      obj.plate = message.plate;
    }
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.chassi !== "") {
      obj.chassi = message.chassi;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_ObjetoRastreavel>, I>>(base?: I): Evento_ObjetoRastreavel {
    return Evento_ObjetoRastreavel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_ObjetoRastreavel>, I>>(object: I): Evento_ObjetoRastreavel {
    const message = createBaseEvento_ObjetoRastreavel();
    message.statusId = object.statusId ?? 0;
    message.subsidiaryId = object.subsidiaryId ?? 0;
    message.plate = object.plate ?? "";
    message.id = object.id ?? 0;
    message.chassi = object.chassi ?? "";
    return message;
  },
};

function createBaseEvento_IdentificacaoMotorista(): Evento_IdentificacaoMotorista {
  return { identificador: "", motoristaid: 0, motoristaNome: "" };
}

export const Evento_IdentificacaoMotorista = {
  encode(message: Evento_IdentificacaoMotorista, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.identificador !== "") {
      writer.uint32(10).string(message.identificador);
    }
    if (message.motoristaid !== 0) {
      writer.uint32(16).int32(message.motoristaid);
    }
    if (message.motoristaNome !== "") {
      writer.uint32(26).string(message.motoristaNome);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Evento_IdentificacaoMotorista {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEvento_IdentificacaoMotorista();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.identificador = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.motoristaid = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.motoristaNome = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Evento_IdentificacaoMotorista {
    return {
      identificador: isSet(object.identificador) ? String(object.identificador) : "",
      motoristaid: isSet(object.motoristaid) ? Number(object.motoristaid) : 0,
      motoristaNome: isSet(object.motoristaNome) ? String(object.motoristaNome) : "",
    };
  },

  toJSON(message: Evento_IdentificacaoMotorista): unknown {
    const obj: any = {};
    if (message.identificador !== "") {
      obj.identificador = message.identificador;
    }
    if (message.motoristaid !== 0) {
      obj.motoristaid = Math.round(message.motoristaid);
    }
    if (message.motoristaNome !== "") {
      obj.motoristaNome = message.motoristaNome;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Evento_IdentificacaoMotorista>, I>>(base?: I): Evento_IdentificacaoMotorista {
    return Evento_IdentificacaoMotorista.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Evento_IdentificacaoMotorista>, I>>(
    object: I,
  ): Evento_IdentificacaoMotorista {
    const message = createBaseEvento_IdentificacaoMotorista();
    message.identificador = object.identificador ?? "";
    message.motoristaid = object.motoristaid ?? 0;
    message.motoristaNome = object.motoristaNome ?? "";
    return message;
  },
};

declare const self: any | undefined;
declare const window: any | undefined;
declare const global: any | undefined;
const tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

function bytesFromBase64(b64: string): Uint8Array {
  if (tsProtoGlobalThis.Buffer) {
    return Uint8Array.from(tsProtoGlobalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = tsProtoGlobalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if (tsProtoGlobalThis.Buffer) {
    return tsProtoGlobalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(String.fromCharCode(byte));
    });
    return tsProtoGlobalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
